import { render, staticRenderFns } from "./MarketingConfigurePage.vue?vue&type=template&id=0449d900&scoped=true&"
import script from "./MarketingConfigurePage.vue?vue&type=script&lang=js&"
export * from "./MarketingConfigurePage.vue?vue&type=script&lang=js&"
import style0 from "./MarketingConfigurePage.vue?vue&type=style&index=0&id=0449d900&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0449d900",
  null
  
)

export default component.exports